import { definePreset } from '@openng/optimus-ui-themes';
import Aura from '@openng/optimus-ui-themes/aura';

import { Tokens } from './tokens';

export const AppTheme = definePreset(Aura, {
	primitive: Tokens.primitive,
	semantic: Tokens.semantic,
	extend: Tokens.extend,
	css: Tokens.css,
	components: Tokens.components,
});

/** The options `provideUi` applies the theme with: `--p-*` variables, the light scheme only, no CSS layer. */
export const AppThemeOptions = {
	prefix: 'p',
	darkModeSelector: 'none',
	cssLayer: false,
} as const;
